// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import {
  AppCheckoutOrderContextType,
  AppContextType,
  AppHeaderBackClickType,
  AppStateContextType,
} from './types/app.contexts.type';
import { LayoutCancelConfigurationType } from 'components/layout/contexts/types/layout.context.type';

const AppContext = createContext<AppContextType>({} as AppContextType);

const AppContextProvider = ({ children }: ReactChildrenType): React.ReactElement => {
  const [backModalConfiguration, setBackModalConfiguration] =
    useState<LayoutCancelConfigurationType>({} as LayoutCancelConfigurationType);
  const [currentState, setCurrentState] = useState<AppStateContextType>(
    AppStatesEnumeration.LOADING
  );
  const [customerName, setCustomerName] = useState<string>('');
  const [checkoutOrderData, setCheckoutOrderData] = useState<AppCheckoutOrderContextType>({});
  const [callbackUrl, setCallbackUrl] = useState<string>('');
  const [loanId, setLoanId] = useState<string>('');
  const [onHeaderBackClick, setOnHeaderBackClick] = useState<AppHeaderBackClickType>(null);

  return (
    <AppContext.Provider
      value={{
        backModalConfiguration,
        callbackUrl,
        checkoutOrderData,
        currentState,
        customerName,
        loanId,
        onHeaderBackClick,
        setBackModalConfiguration,
        setCallbackUrl,
        setCheckoutOrderData,
        setCurrentState,
        setCustomerName,
        setLoanId,
        setOnHeaderBackClick,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContextConsumerHook = (): AppContextType => useContext(AppContext);

export { useAppContextConsumerHook, AppContextProvider };
